import React, { useEffect } from 'react';
import { Button, Text, Card } from '@geist-ui/core';
import { useAuth } from '../../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import './SubscriptionRequired.css';

const SubscriptionRequired = () => {
  const { user, isPatron } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user && (user.is_forced === true || user.isPatron === true)) {
      navigate('/bookshelf');
    }
  }, [user, navigate]);

  return (
    <div className="subscription-page">
      <Card shadow className="subscription-card">
        <div className="subscription-content">
          <img 
            src="https://pub-3cbdf0fe4d9c40f19241eb1a5a52005c.r2.dev/om-assets/chest.webp" 
            alt="Chester icon" 
            className="chester-icon" 
            style={{ width: '80px', height: '80px' }}
          />
          
          <Text h2>Subscription Required</Text>
          
          <Text p>
            <b>ObviousMimic.AI</b> is available exclusively to our Patreon subscribers.
          </Text>
          
          {user ? (
            <div className="subscription-message">
              <Text p>
                Hello, <b>{user.fullName || 'there'}</b>! It looks like you're logged in, 
                but your Patreon subscription status is not active or we couldn't verify it.
              </Text>
              <Text p>Please check your Patreon subscription status and try again.</Text>
            </div>
          ) : (
            <Text p>
              Please login with your Patreon account to access all features.
            </Text>
          )}
          
          <div className="subscription-actions">
            <a 
              href="https://www.patreon.com/obviousmimic" 
              target="_blank" 
              rel="noopener noreferrer"
              className="patreon-link"
            >
              <Button 
                className="theme-button theme-button--cta"
                style={{ 
                  backgroundColor: '#F96854',
                  borderColor: '#F96854',
                  color: 'white'
                }}
              >
                <Text span>Subscribe on Patreon</Text>
              </Button>
            </a>
            
            <Button 
              onClick={() => window.location.href = '/'} 
              className="theme-button"
              type="secondary"
            >
              <Text span>Return to Home</Text>
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default SubscriptionRequired; 